/**
 * A service to manage application settings
 */
import {conditions} from "../utility/conditions";
import is_touch_device = conditions.is_touch_device;
import {L} from "../lt-ng/landcare-toolkit";
import is_high_density = L.is_high_density;

export interface ISettingsService {
	// HDPI tiles
	setHdpi(hdpi : HDPI_Setting) : void;
	getHdpi() : HDPI_Setting;


	// Touch mode
	setInteractionMode(hdpi : Interaction_Setting) : void;
	getInteractionMode() : Interaction_Setting;

	isTouchEnabled() : boolean;

	// Whether science classes should be combined
	setLayerClassMode(mode : LayerClassMode_Setting) : void;
	getLayerClassMode() : LayerClassMode_Setting;
	combinedLayerClasses() : boolean;

	defaultSettings : () => ISettingsHash;

	// setReliefShading(shading: ReliefShading_Setting);
	// getReliefShading() : ReliefShading_Setting;
}

export type HDPI_Setting = "hdpi" | "standard";
// const HDPI_DEFAULT : HDPI_Setting = 'standard';

export type Interaction_Setting = "mouse" | "touch";
// const INTERACTION_DEFAULT : Interaction_Setting = 'auto';

export type LayerClassMode_Setting = "separate" | "combined";
// const LAYER_CLASS_MODE_DEFAULT : LayerClassMode_Setting = 'auto';

// export type ReliefShading_Setting = "on" | "off";

const SETTINGS_KEY = "SMAP_APPLICATION_SETTINGS";

export interface ISettingsHash {
	hdpi : HDPI_Setting;
	interaction: Interaction_Setting;
	layerClassMode : LayerClassMode_Setting;
	// reliefShading?: ReliefShading_Setting;
}

export class SettingsService implements ISettingsService {
	public static $inject = ['$rootScope'];
	protected settings_hash : ISettingsHash;
	constructor(protected $rootScope : ng.IRootScopeService) {
		let settingsSource = window.localStorage.getItem(SETTINGS_KEY);
		this.settings_hash = <ISettingsHash> JSON.parse(settingsSource);
		if (!this.settings_hash) {
			this.settings_hash = this.defaultSettings();
		}

		/*let setShading = () => {
			let shadingOn = this.getReliefShading() == 'on';
			window['composeFn'] = shadingOn ? 'multiply' : null;
		};

		setShading();
		this.$rootScope.$on('settings:reliefShading', setShading);*/

	}

	defaultSettings() : ISettingsHash {
		return {
			hdpi: is_high_density() ? 'hdpi' : 'standard',
			interaction: is_touch_device() ? 'touch' : 'mouse',
			layerClassMode: is_touch_device() ? 'combined' : 'separate'/*,
			reliefShading: 'off'*/
		}
	}

	protected write() : void {
		window.localStorage.setItem(SETTINGS_KEY, JSON.stringify(this.settings_hash));
	}

	protected setSetting(key: string, value: any) {
		let oldValue = this.settings_hash[key];
		this.settings_hash[key] = value;
		if (oldValue != value) {
			this.$rootScope.$broadcast(`settings:${key}`, value, oldValue);
			this.write();
		}
	}

	setHdpi(hdpi: HDPI_Setting): void {
		this.setSetting('hdpi', hdpi);

	}

	getHdpi(): HDPI_Setting {
		return this.settings_hash.hdpi;
	}

	setInteractionMode(interaction: Interaction_Setting): void {
		this.setSetting('interaction', interaction);
	}

	getInteractionMode(): Interaction_Setting {
		return this.settings_hash.interaction;
	}


	isTouchEnabled(): boolean {
		let interaction = this.getInteractionMode();
		return interaction == 'touch';
	}


	setLayerClassMode(mode: LayerClassMode_Setting): void {
		this.setSetting('layerClassMode', mode);
	}

	getLayerClassMode(): LayerClassMode_Setting {
		return this.settings_hash.layerClassMode;
	}

	/*setReliefShading(shading: ReliefShading_Setting): void {
		this.setSetting('reliefShading', shading);

	}

	getReliefShading(): ReliefShading_Setting {
		return this.settings_hash.reliefShading || 'off';
	}*/

	combinedLayerClasses(): boolean {
		let interaction = this.getLayerClassMode();
		return interaction == 'combined';
	}
}